import React, { useState, useRef } from 'react';
import { Grid, Box, Button, Paper, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import { Receipt } from '@mui/icons-material';
import '../../App.css'
import IncomeTaxRulesTable from '../table-data/IncomeTaxRulesTable';
import AddIncomeTaxRulesForm from './AddIncomeTaxRulesForm';
import Popup from '../Popup';

function IncomeTaxRules_Configuration() {
    const [openPopup, setOpenPopup] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const tableRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleCloseModal = () => {
        setOpenPopup(false);
    };

    const handleRefresh = () => {
        // Trigger table refresh
        if (tableRef.current && tableRef.current.refreshTable) {
            tableRef.current.refreshTable();
        }
        // Also trigger refresh via key change as backup
        setRefreshKey(prev => prev + 1);
    };

    return (
        <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px" }}>
            <Paper elevation={5} sx={{ width: "60.5%", maxWidth: "1400px" }}>
                <Grid className="form-title" style={{ marginBottom: "-60px" }} container spacing={2}>
                    <Grid item>
                        <Typography variant="h5" sx={{ textAlign: "center", margin: 5 }}>
                            Income Tax Rules Configuration
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Receipt size={45} style={{ marginLeft: "-50px" }} />
                    </Grid>
                </Grid>
                <form autoComplete="off" onSubmit={handleSubmit}>
                    <Stack spacing={2} sx={{ margin: "33px" }}>
                        <Stack display="flex" sx={{ alignItems: "flex-end", marginRight: "30px" }}>
                            <Button
                                style={{ width: "200px" , marginRight: "60px" }}
                                className="form-btn"
                                variant="outlined"
                                color="success"
                                onClick={() => setOpenPopup(true)}
                                startIcon={<Add sx={{ width: "24px", height: "24px" }} />}
                                sx={{
                                    whiteSpace: "nowrap",
                                    textTransform: "none"
                                }}
                            >
                                Add Income Tax Rule
                            </Button>
                        </Stack>

                        <IncomeTaxRulesTable ref={tableRef} refreshKey={refreshKey} />

                    </Stack>
                </form>

                <Popup
                    title="Add Income Tax Rule"
                    openPopup={openPopup}
                    setOpenPopup={setOpenPopup}
                >
                    <AddIncomeTaxRulesForm 
                        onCloseModal={handleCloseModal}
                        setOpenPopup={setOpenPopup}
                        onRefresh={handleRefresh}
                    />
                </Popup>
            </Paper>
        </Box>
    );
}

export default IncomeTaxRules_Configuration;



